export function isValidMainlandPhone(value: string) {
  return /^1[3-9]\d{9}$/.test(value.trim())
}

export function isValidSmsCode(value: string) {
  return /^\d{6}$/.test(value.trim())
}

export function canRequestSms(phone: string, countdown: number, sending: boolean) {
  return isValidMainlandPhone(phone) && countdown <= 0 && !sending
}

export function canSubmitPhoneAuth(phone: string, code: string, agreed: boolean, sending: boolean, submitting: boolean) {
  return isValidMainlandPhone(phone) && isValidSmsCode(code) && agreed && !sending && !submitting
}
